module.exports = __webpack_public_path__ + "static/media/thumbs-up-active.53f372fb.svg";